import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Nav from '../../../Components/base/nav';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import RichTextEditor from '../../../Components/RichTextEditor'; // Ensure this import is correct
import ChooseImage from '../../../Components/Modal/ChooseImage';
import Sidebar from '../../../Components/base/sidebar';
import { BsEye } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import ActionBar from '../../../Components/Button/ActionBar';
import ContentForm from '../../../Components/Forms/ShowForm';
import Delete from '../../../Components/Button/Delete';
import SEOForm from '../../../Components/Forms/SEOForm';
import StoryDetails from '../../../Components/Forms/StoryDetails';
import TicketForm from '../../../Components/Forms/TicketForm';
import { toast } from "sonner";

export default function LongStory() {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state && location.state.id;
  const [ticket_group_code, setTicketGroupCode] = useState('');
  const [ticket_notes, setTicketNotes] = useState('');
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [postID, setPostID] = useState<string | null>(null);
  const [role, setRole] = useState<string | null>(null);

  const handleTicketGroupCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTicketGroupCode(e.target.value);
  };

  const handleTicketNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTicketNotes(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('ticket_group_code', ticket_group_code);
    formData.append('ticket_notes', ticket_notes);

    try {
      const authToken = localStorage.getItem('authToken');

      if (!authToken) {
        console.error('Authentication token not found!');

        toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
          duration: 1500,
        });
        
        setIsSubmitting(false);
        return;
      }

      if (postID) {
        await axios.post(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${postID}`, formData, 
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          }
        });
      } else {
        const response = await axios.post(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          }
        });

        setPostID(response.data.id);
      }

      toast.success(<p className="text-[16px]">Content submitted successfully.</p>, {
        duration: 1500,
      });

      setTimeout(() => {
        navigate('/view/post/ticket');
      }, 1600);
    } catch (error) {
      console.error("An error occurred during form submission!", error);

      toast.error(<p className="text-[16px]">An error occurred during form submission!</p>, {
        duration: 1500,
      });
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async () => {
  //   setIsSubmitting(true);

  //   const formData = new FormData();
  //   formData.append('category', category);
  //   formData.append('sub_category', sub_category);
  //   formData.append('title', title);
  //   formData.append('body', body);
  //   formData.append('seo_title', seo_title);
  //   formData.append('description', description);
  //   formData.append('sub_head', sub_head);
  //   formData.append('photo_by', photo_by);
  
  //   if (image) {
  //     formData.append('image', image);
  //   }
  
  //   if (imageUrl) {
  //     formData.append('imageUrl', imageUrl);
  //   }

  //   try {
  //     const authToken = localStorage.getItem('authToken');
  //     if (!authToken) {
  //       alert('Authentication token not found!');
  //       setIsSubmitting(false);
  //       return;
  //     }

  //     if (postID) {
  //       await axios.post(`https://stagingbackend.pulp.ph/api/v1/longStory/save/${postID}`, formData, {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       });
  //     } else {
  //       const response = await axios.post(`https://stagingbackend.pulp.ph/api/v1/longStory`, formData, {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //           Authorization: `Bearer ${authToken}`,
  //         }
  //       });

  //       setPostID(response.data.id);
  //     }

  //     alert('Draft Saved Successfully !!');
  //   } catch (error) {
  //     console.error('There was an error saving the draft!', error);
  //     alert(`There was an error saving the draft!, ${error}`);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleViewLongStory = async () => {
    try {
      if (postID) {
        window.open(`https://pulpmagazine.com/article/long_story/${postID}`, '_blank');
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    setRole(storedRole);
  }, []);

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.error('Authentication token not found!');

        toast.error(<p className="text-[16px]">Authentication token not found!</p>, {
            duration: 1500,
        });

        return;
      }

      const confirmDelete = window.confirm('Are you sure you want to delete this content?');
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      };

      if (id) {
        await axios.delete(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${id}`, 
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          }
        })
      };

      toast.success(<p className="text-[16px]">Content deleted successfully.</p>, {
        duration: 1500,
      });

      setTimeout(() => {
        navigate('/view/post/ticket')
      }, 1600);
    } catch (error) {
      console.error("Unable to delete. Please try again.", error);

      toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
        duration: 1500,
      });
    }
  };

  return (
    <>
      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h1 className="GraphikSemibold text-[20px] font-semibold">Edit Ticket Group</h1>
          <ActionBar role={role} onSubmit={handleSubmit} onView={handleViewLongStory} isSubmitting={isSubmitting} isSaved={isSubmitting} />
        </div>

        <div className="py-5 px-4 rounded bg-white">
          <TicketForm ticket_group_code={ticket_group_code} ticket_notes={ticket_notes} onTicketGroupCodeChange={handleTicketGroupCodeChange} onTicketNotesChange={handleTicketNotesChange} />
        </div>
      </div>
    </>
  );
}
